module.exports = __webpack_public_path__ + "static/WelcomeToElk3-1f40b01286578f79c9368dfe53270483.webp";